import { onMount } from 'solid-js'

import { A } from '@solidjs/router'
import './page404.scss'
import { loadingState } from 'store/user'
import { HomeFillIcon, MapFillIcon } from 'icons/navbar'

export default () => {
    let mascotRef: HTMLDivElement

    onMount(async () => {
        if (!mascotRef) return

        const res = await fetch('/public/svgs/wrong.svg')
        const text = await res.text()

        mascotRef.innerHTML = text
    })

    return (
        <section class='page404'>
            <div
                class='mascot-container'
                ref={e => (mascotRef = e)}
                classList={{ active: loadingState.ended }}
            ></div>
            <div class='ctas title_small'>
                <A class='sec' href='/'>
                    <HomeFillIcon />
                    خانه
                </A>
                <A
                    class='main'
                    href='/map'
                    onmousemove={e => {
                        const pos = e.currentTarget.getBoundingClientRect()
                        const mx = e.clientX - pos.left - pos.width / 2
                        const my = e.clientY - pos.top - pos.height / 2

                        e.currentTarget.style.transform = `
                        translate(${mx * 0.1}px ,${my * 0.25}px)
                        rotate3d(${mx * -0.05}, ${my * -0.25}, 0, 12deg)
                        `
                    }}
                    onmouseenter={e => {
                        e.currentTarget.style.transition = ''
                    }}
                    onmouseleave={e => {
                        e.currentTarget.style.transform = ''
                        e.currentTarget.style.transition = '0.2s ease'
                    }}
                >
                    <MapFillIcon />
                    نقشه
                </A>
            </div>
        </section>
    )
}
